module.exports = __webpack_public_path__ + "img/dabaojia-qrcode.4279672e.png";